import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight, Calendar } from 'lucide-react';

/* import Cimg1 from '../assest/mobileclinics/candhra/image1.jpg'; */
import Cimg2 from '../assest/mobileclinics/candhra/image2.jpg';
import Cimg3 from '../assest/mobileclinics/candhra/image3.jpg';
/* import Cimg4 from '../assest/mobileclinics/candhra/image4.jpg'; */

import Bimg1 from '../assest/mobileclinics/BISWABHUSHAN/image1.png';
import Bimg2 from '../assest/mobileclinics/BISWABHUSHAN/image2.png';
import Bimg3 from '../assest/mobileclinics/BISWABHUSHAN/image3.png';


const fadeUp = {
  hidden: {
    opacity: 0,
    y: 60,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: 'easeOut',
    },
  },
};

const fadeLeft = {
  hidden: {
    opacity: 0,
    x: -80,
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 1,
    },
  },
};

const fadeRight = {
  hidden: {
    opacity: 0,
    x: 80,
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 1,
    },
  },
};

const ImageCarousel = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = () => {
    setCurrentIndex(
      currentIndex === 0 ? images.length - 1 : currentIndex - 1
    );
  };

  const nextSlide = () => {
    setCurrentIndex(
      currentIndex === images.length - 1 ? 0 : currentIndex + 1
    );
  };

  return (
    <div className="group relative w-full max-w-[650px] mx-auto h-[180px] sm:h-[240px] md:h-[350px] lg:h-[400px] overflow-hidden rounded-3xl shadow-2xl bg-gray-100">

      <motion.div
        key={currentIndex}
        style={{
          backgroundImage: `url(${images[currentIndex]})`,
        }}
        className="w-full h-full bg-top bg-cover"
        initial={{
          opacity: 0,
          scale: 1.08,
        }}
        animate={{
          opacity: 1,
          scale: 1,
        }}
        transition={{
          duration: 0.7,
        }}
      />

      {/* Navigation Arrows */}
      <motion.button
        whileHover={{ scale: 1.15 }}
        whileTap={{ scale: 0.9 }}
        onClick={prevSlide}
        className="absolute top-1/2 left-4  bg-white/80 hover:bg-white p-2 rounded-full shadow-md transition-all opacity-0 group-hover:opacity-100"
      >
        <ChevronLeft size={24} className="text-gray-800" />
      </motion.button>

      <motion.button
        whileHover={{ scale: 1.15 }}
        whileTap={{ scale: 0.9 }}
        onClick={nextSlide}
        className="absolute top-1/2 right-4  bg-white/80 hover:bg-white p-2 rounded-full shadow-md transition-all opacity-0 group-hover:opacity-100"
      >
        <ChevronRight size={24} className="text-gray-800" />
      </motion.button>

      {/* Indicators */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2">
        {images.map((_, i) => (
          <div
            key={i}
            className={`h-1.5 rounded-full transition-all ${
              currentIndex === i
                ? 'bg-white w-8'
                : 'bg-white/50 w-2'
            }`}
          />
        ))}
      </div>
    </div>
  );
};

const MobileClinics = () => {
  const clinicEvents = [
    {
      title: 'Mobile Dental Facility Launch',
      dignitary: 'Sri Nara Chandra Babu Naidu Garu',
      role: 'Hon\'ble Chief Minister of Andhra Pradesh',
      date: 'July 6, 2017',
      description:
        'Inauguration of our state-of-the-art Mobile Dental facility, bringing advanced oral healthcare directly to the doorsteps of the community.',
      stats: [
        {
          label: 'Launched in',
          value: '1998',
        },
        {
          label: 'Type',
          value: 'Mobile Unit',
        },
      ],
      images: [ Cimg2, Cimg3],
    },
    {
      title: 'Mega Oral Health Camp for Street, Homeless, School, and College Children',
      dignitary: 'Sri Biswabhushan Harichandan Ji',
      role: 'Hon\'ble Governor of Andhra Pradesh',
      date: 'August 2019',
      description:
        "Launch of a massive screening and treatment camp for over 10,000 orphans. To date, Dr. Sridhar's team has reached over 1,000,000 children using two specialized dental buses.",
      stats: [
        {
          label: 'Children Treated',
          value: '12,00,000+',
        },
        {
          label: 'Mobile Units',
          value: '2 Buses',
        },
      ],
      images: [Bimg1, Bimg2, Bimg3],
    },
  ];

return (
<section
  className="
    bg-slate-50
    pt-16 pb-8
    sm:pt-20 sm:pb-10
    md:pt-24 md:pb-12
    lg:pt-26 lg:pb-10
  "
  id="services"
>
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 md:py-10 lg:py-16">

        {/* Section Header */}
        <motion.div
          className="text-center pt-8 lg:pt-12 mb-6 sm:mb-10 lg:mb-20"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={fadeUp}
        >
          <h2 className="text-blue-600 font-bold tracking-widest uppercase text-xs sm:text-sm mb-1">
            Community Outreach
          </h2>

          <h1 className="text-2xl sm:text-4xl md:text-5xl font-extrabold text-slate-900 mb-2 sm:mb-4">
            Mobile Dental Clinics
          </h1>

          <p className="max-w-2xl mx-auto text-slate-600 text-sm sm:text-base lg:text-lg">
            Our specialized dental buses allow us to reach rural areas and underserved communities.
          </p>
        </motion.div>

        {/* Content Blocks */}
        <div className="space-y-14 sm:space-y-20 lg:space-y-32">

          {clinicEvents.map((event, index) => (
            <motion.div
              key={index}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.15 }}
              variants={fadeUp}
              className={`flex flex-col ${
                index % 2 === 0
                  ? 'lg:flex-row'
                  : 'lg:flex-row-reverse'
              } gap-6 sm:gap-8 lg:gap-10 items-center`}
            >

              {/* Image Side */}
              <motion.div
                className="w-full lg:w-[42%]"
                variants={
                  index % 2 === 0
                    ? fadeLeft
                    : fadeRight
                }
              >
                <ImageCarousel images={event.images} />
              </motion.div>

              {/* Text Side */}
              <motion.div
                className="w-full lg:w-[58%] space-y-6"
                variants={
                  index % 2 === 0
                    ? fadeRight
                    : fadeLeft
                }
              >
                <div className="space-y-2">
                  <div className="flex items-center gap-2 text-blue-600 font-semibold">
                    <Calendar size={18} />
                    <span>{event.date}</span>
                  </div>

                  <h3 className="text-3xl font-bold text-slate-900">
                    {event.title}
                  </h3>
                </div>

                <div className="p-4 bg-white rounded-xl border-l-4 border-blue-500 shadow-sm">
                  <p className="text-sm text-slate-500 font-medium uppercase">
                    Inaugurated By
                  </p>

                  <p className="text-xl font-bold text-slate-800">
                    {event.dignitary}
                  </p>

                  <p className="text-slate-600 text-sm">
                    {event.role}
                  </p>
                </div>

                <p className="text-slate-600 text-lg leading-relaxed">
                  {event.description}
                </p>

                {/* Stats */}
                <div className="flex gap-8 border-t border-slate-200 pt-6">
                  {event.stats.map((stat, sIdx) => (
                    <motion.div
                      key={sIdx}
                      whileHover={{
                        y: -5,
                        scale: 1.05,
                      }}
                      transition={{
                        duration: 0.2,
                      }}
                    >
                      <p className="text-2xl font-black text-blue-600">
                        {stat.value}
                      </p>

                      <p className="text-xs text-slate-400 uppercase font-bold tracking-tighter">
                        {stat.label}
                      </p>
                    </motion.div>
                  ))}
                </div>

              </motion.div>
            </motion.div>
          ))}

        </div>
      </div>
    </section>
  );
};

export default MobileClinics;